<template>
  <label :class="['n-radio',disabled?'n-radio-disabled':'',border?'n-radio-border':'']">
    <input :disabled="disabled" name="contact" type="radio" :value="label" :checked="value === label"
           @change="changeVal">
    <span>
      <slot></slot>
    </span>
  </label>
</template>

<script>
export default {
  name: 'bRadio',
  props: {
    /**
     * 绑定值
     * @param value
     */
    value: {
      type: [String, Number],
      default: () => ''
    },
    /**
     * 绑定的名称
     * @param label
     */
    label: {
      type: [String, Number],
      default: () => ''
    },
    /**
     * 启用状态
     * @param disabled
     */
    disabled: {
      type: Boolean,
      default: () => false
    },
    /**
     * 是否为边框单选样式
     * @param border
     */
    border: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    /**
     *
     * @param event
     */
    changeVal (event) {
      this.$emit('change', event)
    }
  }
}
</script>
